const areas = {
  board: 'board',
  answer: 'answer',
  letter: 'letter',
}

const game = {
  areas
};

export default game;
